import { Grid2 as Grid, Link } from "@mui/material";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { ImageBox } from "@sinch/components/ImageBox/ImageBox";
import { MdsIcon } from "@sinch/components";
import { MdsCloseXs } from "@sinch/icons";

interface GalleryAttributeProps {
  files?: { id?: string; name: string; url: string }[] | null;
  // When provided, render a small X overlay on each thumbnail so the admin
  // can drop individual files during profile review without rejecting the
  // entire pending change. Requires `file.id` to be present.
  onRemove?: (fileId: string) => void;
}

const showLimit = 10;

export const GalleryAttribute: FC<GalleryAttributeProps> = ({ files, onRemove }) => {
  const { t } = useTranslation();
  const [showMore, setShowMore] = useState(false);
  if (!files) {
    return null;
  }
  const isMore = files.length > showLimit;
  const filesToDisplay = showMore || !isMore ? files : files.slice(0, showLimit);

  return (
    <>
      <Grid container spacing={1}>
        {filesToDisplay.map((file) => (
          <Grid key={file.url}>
            <Box sx={{ position: "relative", display: "inline-block" }}>
              <ImageBox
                disabled={false}
                exactSize
                imgHeight={64}
                imgWidth={64}
                lightbox
                render={({ width, height, setRef }) => (
                  <img ref={setRef} alt={file.name} height={height} src={file.url} width={width} />
                )}
              ></ImageBox>
              {onRemove !== undefined && file.id !== undefined && (
                <IconButton
                  aria-label="remove"
                  onClick={(e) => {
                    e.stopPropagation();
                    onRemove(file.id!);
                  }}
                  size="small"
                  sx={{
                    position: "absolute",
                    top: -6,
                    right: -6,
                    width: 20,
                    height: 20,
                    padding: 0,
                    bgcolor: "error.main",
                    color: "common.white",
                    "&:hover": { bgcolor: "error.dark" },
                  }}
                >
                  <MdsIcon icon={MdsCloseXs} sx={{ fontSize: 14 }} />
                </IconButton>
              )}
            </Box>
          </Grid>
        ))}
      </Grid>
      {isMore && (
        <Link
          onClick={() => setShowMore(!showMore)}
          sx={{
            pt: 1,
          }}
          target="_blank"
        >
          {showMore ? t("showLess") : t("showMore")}
        </Link>
      )}
    </>
  );
};
